import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Modal as AntModal,
  Avatar,
  Button,
  Col,
  Flex,
  message,
  Row,
  Space,
  Tag,
} from "antd";
import { getFormattedNumber } from "../../../../utils";
import { IconCheckLight } from "../../../../assets/icons";
// import RejectReasonModal from "../RejectReasonModal/RejectReasonModal";
import api from "../../../../api/api";
import { CopyOutlined, CloseCircleOutlined } from "@ant-design/icons";
import RejectReasonForCheckModal from "./RejectReasonFroCheckModal";
import { useAtom } from "jotai";
import { orderCount } from "../../../../utils/atom";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const Modal = styled(AntModal)`
  .ant-modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e1e1e;
  }
  .ant-modal-close svg {
    font-size: 24px;
  }
  .ant-modal-body {
    .ant-btn-default {
      border: 1px solid #ffc8c8 !important;
      background: #ffe6e8 !important;
      color: #f00 !important;
      :hover {
        background: #ffe6e8 !important;
      }
    }
  }
  .ant-modal-footer .ant-row {
    .ant-col:first-child,
    .ant-col:nth-child(3) {
      text-align: left;
    }
    .ant-col:last-child {
      text-align: right;
    }
    .ant-btn-default {
      width: 100%;
      height: 56px;
      border: 1px solid #ffc8c8 !important;
      background: #ffe6e8 !important;
      color: #f00 !important;
      :hover {
        background: #ffe6e8 !important;
      }
    }
    .ant-btn-primary {
      width: 100%;
      height: 56px;
    }
  }
`;

const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #1e1e1e;
`;

const BoldText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1e1e1e;
`;

const TotalText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #1e1e1e;
`;

const Card = styled.div`
  height: 100%;
  padding: 12px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 8px;
  background: #f7f7f7;
  .ss-image {
    width: 80px;
    aspect-ratio: 1;
    border-radius: 8px;
  }
  .custom-avatar {
    border: 1px solid #b9b9b9;
    border-radius: 8px;
    background: ${(props) => props.theme.backgroundColor};
  }
`;

const NormalText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #1d1014;
  line-height: 1;
`;

const GrayText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #868686;
  white-space: pre-wrap;
`;

const CancelTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  font-size: 14px;
  color: #f00;
  margin-top: 4px;
  background: #ffe6e8;
  padding: 4px 8px;
  border-radius: 8px;
  svg {
    cursor: pointer;
    font-size: 16px;
  }
`;

const CheckModal = ({
  open,
  id,
  total_price,
  products = [],
  handleClose,
  successCallback,
  setData,
  productCount,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [product, setProduct] = useState({});
  const [cancelType, setCancelType] = useState("");
  const [pendingCancellations, setPendingCancellations] = useState([]);
  const [options, setOptions] = useState([]);
  const [cancellingReason, setCancellingReason] = useState({});
  const [allCancelId, setAllCancelId] = useState("");
  const [disableCancelAll, setDisableCancelAll] = useState(false);
  const [orderStatus, setOrderStatus] = useAtom(orderCount);

  const {t} = useTranslation();
  
  const {status} = useParams();


  // Auto-close if all products already canceled
  useEffect(() => {
    const cancelledCount = products.filter((p) => p.is_cancel).length;
    if (open && products.length === cancelledCount && cancelledCount > 0) {
      handleClose();
      successCallback();
    }
  }, [open, products, handleClose, successCallback]);

  // Handle single product cancel
  const handleProductCancel = (product) => {
    setProduct(product);
    setCancelType("product");
    setOpenRejectModal(true);
    setDisableCancelAll(true);
  };

  // Cancel all products
  const cancelAll = () => {
    setCancelType("all");
    setOpenRejectModal(true);
  };

  const handleRejectClose = () => {
    setOpenRejectModal(false);
    setCancelType("");
    setProduct({});
  };
  // On success: store cancellation reason
  const handleSuccess = (cancel_reason,id) => {
    setAllCancelId(id);
    if (cancelType === "all") {
      // Cancel all non-canceled products
      const allToCancel = products
        .filter((p) => !p.is_cancel)
        .map((p) => ({
          p_id: p.id,
          product_id: p.product_id,
          variant_id: p.variant_id,
          cancel_reason,
        }));
      setPendingCancellations((prev) => [...prev, ...allToCancel]);
      setCancellingReason(cancel_reason);
      handleRejectClose();
    } else {
      // Cancel single product
      setPendingCancellations((prev) => [
        ...prev,
        {
          p_id: product.id,
          product_id: product.product_id,
          variant_id: product.variant_id,
          cancel_reason,
        },
      ]);
      handleRejectClose();
    }
  };
  // Remove a pending cancellation
  const removePending = (p_id) => {
    setPendingCancellations((prev) =>
      prev.filter((item) => item.p_id !== p_id)
    );
  };
    
    const calculation = (Number(productCount) || 0) - (pendingCancellations?.length || 0);

  const handleConfirm = () => {
    if (confirmLoading) {return};
    setConfirmLoading(true);

    if(cancelType === "all"){
      api.cancelAllOrders({ id : id, cancel_type:null, cancel_reason:null, cancellation_reason:cancellingReason})
      .then(() => {
         message.success("Order canceled!");
         setData((prev) => ({
            ...prev,
            OrderProducts: prev.OrderProducts.map((p) => {
              const found = pendingCancellations.find((c) => c.p_id === p.id);
              if (found) {
                return {
                  ...p,
                  is_cancel: true,
                  cancel_reason: found.cancel_reason,
                };
              }
              return p;
            }),
          }));
          handleClose();
          successCallback();
          setOrderStatus(!orderStatus);
      })
        .catch((error) => {
          message.error("Failed to cancel order.");
          console.error(error);
        })
        .finally(() => {
          setConfirmLoading(false);
        });
        return;
    }

    if (pendingCancellations.length > 0 && cancelType !== "all") {
      // Step 1: Cancel multiple products
      api
        .cancelOrderProducts(id, pendingCancellations)
        .then(() => {
          // Step 2: Confirm order after cancellation
          if(calculation !==  0){
          return api.confirmOrder(id,{
            order_status:  status === "PENDING" ? "CONFIRMED" : status === "PAYMENT_PENDING" ?  "PENDING" : "COMPLETED",
          });
          }
        })
        .then(() => {
          message.success(t('order_confirmed_cancelled'));
          // Update UI
          setData((prev) => ({
            ...prev,
            OrderProducts: prev.OrderProducts.map((p) => {
              const found = pendingCancellations.find((c) => c.p_id === p.id);
              if (found) {
                return {
                  ...p,
                  is_cancel: true,
                  cancel_reason: found.cancel_reason,
                };
              }
              return p;
            }),
          }));
          handleClose();
          successCallback();
          setOrderStatus(!orderStatus);
        })
        .catch((error) => {
          message.error("Failed to cancel products or confirm order.");
          console.error(error);
        })
        .finally(() => {
          setConfirmLoading(false);
        });
    } else {
      // No pending cancellations, just confirm
      api
        .confirmOrder(id,{
            order_status:  status === "PENDING" ? "CONFIRMED" : status === "PAYMENT_PENDING" ?  "PENDING" : "COMPLETED",
          })
        .then(() => {
          message.success(t('order_confirmed'));
          handleClose();
          successCallback();
          setOrderStatus(!orderStatus);
        })
        .catch((error) => {
          message.error(error.message || "Failed to confirm order.");
        })
        .finally(() => {
          setConfirmLoading(false);
        });
    }
  };

  const onCancel = () => {
    if (!confirmLoading) {
      handleClose();
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      message.success(t('copy_to'));
    });
  };

  const getCancelReason = () => {
    api
      .getCancelReason()
      .then((res) => setOptions(res.data || []))
      .catch((err) => message.error(err));
  };

  useEffect(() => {
    getCancelReason();
  }, []);

  useEffect(() => {
  if (!allCancelId || options.length === 0) return;

  const found = options.find((opt) => opt.id === allCancelId);
  if (found) {
    setCancellingReason(found.name);
  }
}, [allCancelId, options]);


  return (
    <>
      <Modal
        centered
        width={576}
        open={open}
        onCancel={onCancel}
        title={t('order_checking')}
        footer={
          <Row gutter={[16, 8]}>
            <Col xs={12}>
              <Text>{t('total_price')}</Text>
            </Col>
            <Col xs={12}>
              <TotalText>{getFormattedNumber(total_price)}</TotalText>
            </Col>
            {pendingCancellations.length > 0 && (
              <Col xs={24}>
                <GrayText>
                  {pendingCancellations.length} {t('items_will_cancel')}
                </GrayText>
              </Col>
            )}
            <Col xs={12}>
              <Button disabled={disableCancelAll} type="default" onClick={cancelAll}>
                {t('cancelled_btn')}
              </Button>
            </Col>
            <Col xs={12}>
              <Button
                type="primary"
                icon={<IconCheckLight />}
                onClick={handleConfirm}
                loading={confirmLoading}
              >
                {t('confirm')}
              </Button>
            </Col>
          </Row>
        }
      >
        <Flex style={{ flexDirection: "column", gap: 8 }}>
          {products.map((product, key) => {
            // Check if this product is already canceled OR pending cancellation
            const isCanceled = product.is_cancel;
            const isPending = pendingCancellations.find(
              (c) => c.p_id === product.id
            );

            return (
              <Card key={key}>
                <Avatar
                  shape="square"
                  size={100}
                  src={
                    product.product.has_variant
                      ? product.variant.image_url
                      : product.product.thumb_image
                  }
                />
                <Space direction="vertical" style={{ flex: 1 }}>
                  <Row>
                    <Col xs={12}>
                      <GrayText
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopy(product?.product?.sku);
                        }}
                        style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                      >
                        {product?.product?.sku}
                        <CopyOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(product?.product?.sku);
                          }}
                          style={{
                            cursor: "pointer",
                            color: "gray",
                            paddingLeft: "4px",
                          }}
                        />
                      </GrayText>
                    </Col>
                  </Row>
                  <NormalText>{product?.product?.name?.primary}</NormalText>
                  <Flex align="center" gap={2}>
                    {product?.variant?.ProductVariantCombinations?.map(
                      (v, key) => (
                        <Tag
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "none",
                            padding: "4px 8px",
                            fontWeight: 500,
                          }}
                          key={key}
                        >
                          {v.variant_value?.name}
                        </Tag>
                      )
                    )}
                  </Flex>
                  <Row>
                    <Col xs={12}>
                      <NormalText>
                        {t('qty')}: {getFormattedNumber(product.quantity)}
                      </NormalText>
                    </Col>
                    <Col xs={12} style={{ textAlign: "right" }}>
                      <BoldText>{getFormattedNumber(product.price)}</BoldText>
                    </Col>
                  </Row>

                  {/* Show Cancel Reason + Remove Button if pending */}
                  {isPending && (
                    <CancelTag>
                      {t('cancel')}: {isPending.cancel_reason?.primary}
                      <CloseCircleOutlined
                        onClick={() => 
                        {
                          removePending(product.id);
                          setDisableCancelAll(false);
                        }
                          
                        }
                      />
                    </CancelTag>
                  )}

                  {/* Show "Cancelled" if already canceled */}
                  {isCanceled && !isPending && (
                    <CancelTag>{t('cancelled')} {product.cancel_reason?.primary}.</CancelTag>
                  )}

                  {/* Show Cancel Button if not canceled and not pending */}
                  {!isCanceled && !isPending && (
                    <Row>
                      <Col xs={12} />
                      <Col xs={12} style={{ textAlign: "right" }}>
                        <Button
                          type="default"
                          onClick={() => handleProductCancel(product)}
                        >
                          {t('cancel')}
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Space>
              </Card>
            );
          })}
        </Flex>
      </Modal>

      {/* Reject Reason Modal */}
      <RejectReasonForCheckModal
        type={cancelType}
        id={id}
        p_id={product.id}
        product_id={product.product_id}
        variant_id={product.variant_id}
        open={openRejectModal}
        handleClose={handleRejectClose}
        successCallback={handleSuccess}
        cancelType={cancelType}
        setCancelTypeAll={setCancelType}
      />
    </>
  );
};

export default CheckModal;
